<template>
  <v-row>
    <v-col v-for="item in planes" :key="item.id" cols="4">
      <v-card @click="selectPlane(item)" :class="{
        selected: isSelected(item),
      }">
        <v-card-title>
          {{ item.title }}
          <v-spacer></v-spacer>
          <v-chip v-if="userCount(item) > 0" small color="amber" text-color="black">
            {{ userCount(item) }}
            user{{ userCount(item) === 1 ? "" : "s" }}
          </v-chip>
        </v-card-title>
        <v-card-text>
          <img :src="item.src" class="plane-img" />
          <v-icon class="chk" v-if="isSelected(item)">mdi-check</v-icon>
          <div v-if="userEmails(item).length" class="pt-2 caption grey--text text--darken-1">
            <div>Picked by:</div>
            <div v-for="email in userEmails(item)" :key="email" class="text-truncate">
              {{ email }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import lodash from "lodash";
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserFlyPlaneSelection",
  props: {
    selectedPlane: { type: Object, default: () => { } },
  },
  data() {
    return {
      planeDocs: [],
      profileCache: {},
      unsubscribe: null,
    };
  },
  computed: {
    planes() {
      const list = this.currentProjectModel
        ? this.currentProjectModel.planesOrder || []
        : [];
      const canonicalById = {};
      (this.currentPlanes || []).forEach((p) => {
        if (p && p.id) canonicalById[p.id] = p;
      });
      const merged = list.map((item) => {
        const canon = canonicalById[item.id];
        return canon ? { ...item, ...canon, index: item.index } : item;
      });
      return lodash.orderBy(merged, "index", "asc");
    },
    planeCounts() {
      const counts = {};
      this.planeDocs.forEach((d) => {
        counts[d.planeId] = (counts[d.planeId] || 0) + 1;
      });
      return counts;
    },
    planeEmails() {
      const emails = {};
      this.planeDocs.forEach((d) => {
        const email = this.profileCache[d.uid];
        if (!email) return;
        if (!emails[d.planeId]) emails[d.planeId] = [];
        if (!emails[d.planeId].includes(email)) {
          emails[d.planeId].push(email);
        }
      });
      return emails;
    },
    ...mapState([
      "currentProject",
      "currentProjectModel",
      "currentUser",
      "currentPlanes",
    ]),
  },
  watch: {
    "currentProjectModel.id": {
      immediate: true,
      handler(pid) {
        this.subscribeCounts(pid);
      },
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    subscribeCounts(pid) {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      if (!pid) return;
      this.unsubscribe = fb.flyExCollection
        .where("pid", "==", pid)
        .onSnapshot((snap) => {
          const docs = [];
          snap.forEach((docSnap) => {
            const data = docSnap.data();
            const planeId =
              data.doc &&
              data.doc.selectedPlane &&
              data.doc.selectedPlane.id;
            if (!planeId || !data.uid) return;
            docs.push({ uid: data.uid, planeId });
            this.fetchProfile(data.uid);
          });
          this.planeDocs = docs;
        });
    },
    fetchProfile(uid) {
      if (!uid) return;
      if (uid in this.profileCache) return;
      this.$set(this.profileCache, uid, null);
      fb.profilesCollection
        .where("uid", "==", uid)
        .get()
        .then((snap) => {
          const doc = snap.docs[0] && snap.docs[0].data();
          this.$set(this.profileCache, uid, (doc && doc.email) || null);
        })
        .catch(() => {
          this.$set(this.profileCache, uid, null);
        });
    },
    selectPlane(item) {
      console.log("selectPlane", item);
      this.$emit("updated", item);
    },
    isSelected(item) {
      if (this.selectedPlane) {
        return this.selectedPlane.id === item.id;
      } else {
        return false;
      }
    },
    userCount(item) {
      return this.planeCounts[item.id] || 0;
    },
    userEmails(item) {
      return this.planeEmails[item.id] || [];
    },
  },
};
</script>

<style lang="scss">
.disabled {
  opacity: 0.5;
}

.selected {
  border: 4px solid white !important;
}

.plane-img {
  display: block;
  width: 100%;
  height: auto;
}

.boarding {
  .v-card__title {
    background: #ffc107;
    padding-top: 1rem !important;
    padding-bottom: 2rem !important;
  }

  .v-card__subtitle {
    background: #e0e0e0;
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .v-card__actions {
    background: #ffe082;
    padding-top: 0.5rem !important;
    padding-bottom: 1rem !important;
  }
}
</style>
